import { FormButton } from "../../../components/_input/_button";
import BackHeading from "../../../components/backHeading";
import SimpleButton from "../../../components/_input/SimpleButton";
import PopupWithHeading from "../../../components/popupWithHeading"
import AddressInsert from "./addressInsert";
import { saveData, User_Data_Key, getData } from "../../../utils/localStorageManager";
import { Suspense, useCallback, useState, useEffect } from "react";
import config from '../../../configuration/config.json'
import axios from "axios";
import { useTranslation } from "react-i18next";
import Skeleton from 'react-loading-skeleton'
function AddressSelection({ nameSubmit = "حفظ", submitRequest }) {
    const { t: trans, i18n } = useTranslation(["mobileHeading", "new", 'error']);
    let lang = localStorage.getItem("i18nextLng");
    const languageDir = 'language-' + localStorage.getItem('i18nextLng');
    const [showPopup, setShowPopup] = useState(false);
    const [data, setData] = useState(null);
    const [optionType, setOptionType] = useState(null);
    const [optionTitle, setOptionTitle] = useState('اضافة عنوان');
    const [userName, setUserName] = useState(null);
    const [address, setAddress] = useState([]);
    const [isLoadingAddress, setLoadingAddress] = useState(true);
    useEffect(() => {
        try {
            let _userData = JSON.parse(getData(User_Data_Key, true));
            console.log("_userData:", _userData);
            console.log("_userData:", _userData?.userId);
            setUserName(_userData?.userName);
            setAddress([]);
        } catch (error) {

        }

        callback();


    }, []);

    const callback = useCallback(async () => {
        setLoadingAddress(true);
        var userId = ""
        try {
            let _userData = JSON.parse(getData(User_Data_Key, true));
            userId = _userData?.userId;
        } catch (error) {

        }
        await axios.request({
            url: config.controllerUrl + 'api/MyOrders/GetUserAddresses',
            data: { userId: userId + "" }, method: "POST", responseType: "json"
        })
            .then(function (response) {
                console.log("FetchTypeCart:", response.data);
                setAddress(response.data);
                setLoadingAddress(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoadingAddress(false);
            });







    }, []);

    return (

        <>
            <div className={`address-selection-page container mb-32 nice-apply-theme `}>

                {/* <BackHeading title={'العنوان'} /> */}


                <div className="address-selection-body nice-apply-theme">

                    {



                        isLoadingAddress ? (

                            <>

                                <div className="container my-10 text-center nice-apply-theme">

                                    <Skeleton count={3} borderRadius={"2rem"}
                                        width={"100%"} height={"25rem"} containerClassName={""}
                                        className={"my-5"} inline={false} />

                                </div>

                            </>
                        ) : (


                            address.map((item, index) => {

                                return (

                                    <article key={index} className="address-selection-part nice-container">

                                        <div className="address-selection-part-radio">
                                            <input value={index} name={"address-selection"}
                                                className={""}
                                                onClick={() => {
                                                    setData(item);
                                                }}
                                                type="radio" />
                                        </div>

                                        <div className="address-selection-part-content">
                                            <div className="flex flex-row justify-between">

                                                <span className="text-30 text-bold">{lang == "ar" ? item?.DescriptionAr : item?.DescriptionEn}</span>

                                            </div>
                                            <div className="flex flex-row nice-gap-2rem">
                                                <span className="text-30 ">{item?.address}</span>
                                            </div>
                                            <div className="flex flex-row nice-gap-2rem">
                                                <span className="text-30">{trans(`new:country`)}:</span>
                                                <span className="text-30 ">{lang == "ar" ? item?.CountryAr : item?.CountryEn}</span>
                                            </div>
                                            <div className="flex flex-row nice-gap-2rem">
                                                <span className="text-30">{trans(`new:mobile`)}:</span>
                                                <span className="text-30 ">{item?.Mobile}</span>
                                            </div>
                                            {/* <div className="flex flex-row nice-gap-2rem ">
                                            <a className="text-30 text-bold text-primary" href="#">تعديل</a>
                                            <a className="text-30 text-bold text-note" href="#">حذف</a>
                                        </div> */}

                                        </div>
                                    </article>

                                );
                            })



                        )
                    }

                    {/* 
                    <div className="add-address">

                        <button className="text-30 text-bold"
                            onClick={() => {
                                setShowPopup(true);
                            }}

                        >اضافة عنوان</button>
                    </div> */}
                </div>


                <FormButton name={nameSubmit}
                    //  isLoading={isLoading} 
                    //  onClick={submitRequest}

                    onClick={() => {
                        if (data) {
                            if (submitRequest)
                                submitRequest(data);
                        }
                    }}
                />

            </div>

            <PopupWithHeading
                show={showPopup}
                title={optionTitle}
                onStatusChange={(status) => {
                    setShowPopup(false);
                }}
            >
                <AddressInsert />
            </PopupWithHeading>
        </>
    );
}

export default AddressSelection;
